<template>
  <div
    :padding="$breakpoint.xs ? 2 : 3"
    class="flex flex-wrap items-center justify-between px-2 gap-y-4 xl:flex-no-wrap"
  >
    <div
      class="flex flex-wrap items-center order-2 w-full mt-8 text-center lg:order-1 lg:mt-0 lg:text-left lg:w-auto sm:flex-no-wrap"
    >
      <p>
        Showing
        <span class="font-medium">
          {{ currentPage * hitsPerPage - hitsPerPage + 1 }}
        </span>
        to
        <span class="font-medium">{{ compIsLastPage ? totalResults : currentPage * hitsPerPage }}</span>
        of
        <span class="font-medium">{{ totalResults }}</span>
        results
      </p>

      <FormSelect
        name="hitsPerPage"
        :items="compHitsPerPageOptions"
        :emptyFirstOption="false"
        :value="hitsPerPage"
        @change="hitsPerPage => $emit('changeHitsPerPage', hitsPerPage)"
        class="w-full mt-4 mb-0 ml-0 sm:w-auto sm:mt-0 sm:ml-4 sm:mr-4"
        small
      />
    </div>

    <ul class="flex items-center order-1 w-auto bg-white border rounded select-none md:order-2 border-gray">
      <li v-if="!compIsFirstPage">
        <a
          :href="`/?${generateUrl({ page: 1 })}`"
          @click.prevent="$emit('changePage', 1)"
          class="block px-4 py-1 border-r border-gray"
        >
          <FontAwesomeIcon :icon="faChevronDoubleLeft" class="text-sm" />
        </a>
      </li>

      <li v-if="!compIsFirstPage">
        <a
          :href="`/?${generateUrl({ page: currentPage - 1 })}`"
          @click.prevent="$emit('changePage', currentPage - 1)"
          class="block px-4 py-1 border-r border-gray"
        >
          <FontAwesomeIcon :icon="faChevronLeft" class="text-sm" />
        </a>
      </li>

      <li v-for="pageNumber in compAvailablePages" :key="pageNumber">
        <a
          :href="`/?${generateUrl({ page: pageNumber })}`"
          @click.prevent="$emit('changePage', pageNumber)"
          class="block px-4 py-1 border-r border-gray hover:bg-gray-lightest"
          :class="{
            'border-none rounded-r': compIsLastPage && pageNumber === currentPage,
            'rounded-l': compIsFirstPage,
            'bg-gray-lighter': pageNumber === currentPage
          }"
        >
          {{ pageNumber }}
        </a>
      </li>

      <li v-if="!compIsLastPage">
        <a
          :href="`/?${generateUrl({ page: currentPage + 1 })}`"
          @click.prevent="$emit('changePage', currentPage + 1)"
          class="block px-4 py-1 border-r border-gray"
        >
          <FontAwesomeIcon :icon="faChevronRight" class="text-sm" />
        </a>
      </li>

      <li v-if="!compIsLastPage">
        <a
          :href="`/?${generateUrl({ page: totalPages })}`"
          @click.prevent="$emit('changePage', totalPages)"
          class="block px-4 py-1"
        >
          <FontAwesomeIcon :icon="faChevronDoubleRight" class="text-sm" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  faChevronRight,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronDoubleLeft
} from '@fortawesome/pro-regular-svg-icons'
import FormSelect from '@/components/forms/elements/FormSelect'

export default {
  name: 'UtilPagination',
  components: {
    FormSelect
  },
  props: {
    hitsPerPage: Number,
    currentPage: Number,
    totalPages: Number,
    totalResults: Number,
    maxVisiblePages: {
      type: Number,
      default: 7
    },
    generateUrl: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      faChevronRight,
      faChevronDoubleRight,
      faChevronLeft,
      faChevronDoubleLeft
    }
  },
  computed: {
    compAvailablePages() {
      // Limit number of available pages to choose from
      let maxVisiblePages = this.maxVisiblePages

      if (maxVisiblePages > this.totalPages) {
        maxVisiblePages = this.totalPages
      }

      let start = this.currentPage - Math.floor(maxVisiblePages / 2)
      start = Math.max(start, 1)
      start = Math.min(start, 1 + this.totalPages - maxVisiblePages)

      let test = Array.from({ length: maxVisiblePages }, (el, i) => start + i)

      return test
    },

    compIsFirstPage() {
      return this.currentPage - 1 === 0
    },

    compIsLastPage() {
      return this.currentPage === this.totalPages
    },

    compHitsPerPageOptions() {
      let possibleValues = [12, 20, 40]

      return possibleValues.map(option => ({
        text: `${option} hits per page`,
        value: option
      }))
    }
  }
}
</script>
